import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
	AlertController,
	ModalController,
	PopoverController,
} from '@ionic/angular';
import { filter, Observable, tap } from 'rxjs';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { companyScheduleFormFeild } from '../../forms/set-company-schedule';
import { ParticipateCompanyService } from '../participatingcompanies/service/participate-company.service';
import { ScheduleService } from './service/schedule.service';

@Component({
	selector: 'app-schedule',
	templateUrl: './schedule.page.html',
	styleUrls: ['./schedule.page.scss'],
})
export class SchedulePage implements OnInit {
	employees$: Observable<any> = new Observable();
	jobfairId: number = 0;

	participatingCompanies$: any;
	constructor(
		public popoverController: PopoverController,
		public modalController: ModalController,
		public scheduleService: ScheduleService,
		private location: Location,
		private alertController: AlertController,
		private participateCompanyService: ParticipateCompanyService,
	) {
		//
	}

	ngOnInit() {
		const locationPath: Array<string | any> = this.location.path().split('/');
		this.jobfairId = locationPath[4];
		// this.getJobfairSchedule(this.jobfairId);
		this.scheduleService.loadScheduleinit(this.jobfairId).subscribe();
		this.scheduleService.loadScheduleapi(this.jobfairId).subscribe();
		this.employees$ = this.scheduleService.fetchScheduledata(this.jobfairId);
		// this.getJobfairSchedule(this.jobfairId);

		this.participateCompanyService.loadcompanyapi(this.jobfairId).subscribe();
		this.participatingCompanies$ = this.participateCompanyService
			.fetchcompanydata(this.jobfairId)
			.pipe(
				tap(data => console.log(data, 'data company')),
				filter((data: any) => !data.isSkeleton && data.data),
			);
	}

	isCanOpenBox = true;

	async addJobfair(participatingCompany: any) {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Add company slot',
					form: companyScheduleFormFeild,

					selectOptions: {
						selectCompany: participatingCompany.data.filter(
							(company: any) => company.status == 'approved',
						),
					},
					jobfairId: this.jobfairId,
					onSubmitForm: this.onCreate,
					isUpdate: false,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			const { data } = await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}

	onCreate(ref: any, editForm: any) {
		if (editForm.id == null) {
			editForm.id = editForm.selectCompany;
		}
		return ref.scheduleService.addUpdateSchedule(this.jobfairId, editForm.id, {
			startTime: new Date(editForm.jobFairDate).getTime(),
			endTime: new Date(editForm.endDate).getTime(),
		});
	}

	async editInfo(schedule: any, participatingCompany: any) {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;

			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					form: companyScheduleFormFeild,
					formTitle: 'Edit company slot',
					values: {
						selectCompany: schedule.name,
						jobFairDate: new Date(schedule.startTime),
						endDate: new Date(schedule.endTime),
						id: schedule.companyId,
					},
					selectOptions: {
						selectCompany: participatingCompany.data,
					},
					jobfairId: this.jobfairId,
					isUpdate: true,
					onSubmitForm: this.onCreate,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			const { data } = await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}

	deleteSchedule(compnayId: any) {
		this.scheduleService
			.deleteSchedule(this.jobfairId, compnayId)
			.subscribe(() => {
				// this.getJobfairSchedule(this.jobfairId);
			});
	}
}
